import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { bankIDSigning, bankIDSigningReset } from './actions';

export function useBankIDSigning() {
  const {
    isSuccessful,
    loading,
    error,
    orderRef,
    isInitSuccessful,
  } = useSelector(state => state.bankIDSigning);

  const dispatch = useDispatch();

  useEffect(() => () => dispatch(bankIDSigningReset()), [dispatch]);

  return {
    isSuccessful,
    loading,
    error,
    orderRef,
    isInitSuccessful,
    onSignWithBankID: (personalNumber, userVisibleData) => dispatch(bankIDSigning(personalNumber, userVisibleData)),
  };
}
